import { Cog6ToothIcon } from '@heroicons/react/24/solid';
import { wardsNavigate } from '../../router/WardsScreenRegistration';
import { WaScreensMap } from '../../router/WardsScreenMap';
import { useNavigate } from 'react-router-dom';
import { WA_Screen } from '../../router/WardsScreens';
import { useTranslation } from 'react-i18next';
import { useWaProductStore } from 'src/api/wa/store/WaProductStore';
import { useEffect } from 'react';
import useWaProductService from 'src/api/wa/service/WaProductService';
import { useWaWorkplaceStore } from 'src/api/wa/store/WaWorkplaceStore';

function RelatedDetailsCell() {
  const navigate = useNavigate();
  const { productMasterInfo } = useWaProductStore();
  const { t } = useTranslation();
  const { fetchProductMasterInfo } = useWaProductService();
  const { selectedWorkplace } = useWaWorkplaceStore();

  useEffect(() => {
    if (selectedWorkplace) {
      fetchProductMasterInfo(selectedWorkplace);
    }
  }, [fetchProductMasterInfo, selectedWorkplace]);

  return (
    <div
      className="flex w-full items-center rounded border border-gray-200 bg-white p-2 shadow-sm"
      onClick={() => {
        wardsNavigate(navigate, WaScreensMap[WA_Screen.ProductList].path);
      }}
    >
      <div className="mr-3 flex size-8 shrink-0 items-center justify-center rounded bg-red-300 text-white">
        <Cog6ToothIcon className="size-4" />
      </div>
      <div className="flex flex-1 items-center justify-center text-sm text-gray-800">
        <span>{t('wards.siteDetails.relatedProductsTitle')}</span>(
        <span className="font-bold">{productMasterInfo.length}</span>)
      </div>
    </div>
  );
}

export default RelatedDetailsCell;
